// extracted by mini-css-extract-plugin
export default {"he":"SignUp_he__BS9qj","link":"SignUp_link__oZ+6d"};